// extracted by mini-css-extract-plugin
export default {"accordionHeader":"zj1gdcXrXWxCyM4W3zFpo","accordionHeaderTitle":"_79ph8Mnoh46d19bFrGOFuw","toggleButton":"_58aX2s2Cx8a7OqKR8ngS1R"};